// Get the desired date format
const formatRaceDate = (dateString) => {
  const date = new Date(dateString);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

export default formatRaceDate